import { ref } from "vue";

//此函数用来绘制多边形
let polygonHandler = null as any;
let polygonHandler2 = null as any;
let circleHandler = null as any;
declare const Cesium: any;
// 清理所有绘制处理器
export function clearDrawHandlers() {
  if (polygonHandler && !polygonHandler.isDestroyed()) {
    polygonHandler.destroy();
    polygonHandler = null;
  }
  if (polygonHandler2 && !polygonHandler2.isDestroyed()) {
    polygonHandler2.destroy();
    polygonHandler2 = null;
  }
  if (circleHandler && !circleHandler.isDestroyed()) {
    circleHandler.destroy();
    circleHandler = null;
  }
}

import pointYellowImg from "/@/assets/icons/table/point-img.png";
import timeImg from "/@/assets/icons/table/gs-time.png";
import infoImg from "/@/assets/icons/table/gs-info.png";
import compareImg1 from "/@/assets/icons/table/gs-car.png";
import compareImg2 from "/@/assets/icons/table/gs-lt.png";
import compareImg3 from "/@/assets/icons/table/gs-ny.png";
import compareImg4 from "/@/assets/icons/table/gs-common.png";
import compareImg5 from "/@/assets/icons/table/gs-people.png";

const pointImgFlag = ref(false);
const typeNum = ref(1);
export function drawPolygon(type: number, viewer: any, callback: any) {
  // callback('123')
  // console.log('用来控制多边形的绘制')
  typeNum.value = type;
  //   let polygonColor = Cesium.Color.RED.withAlpha(0.5); // 矩形内部颜色
  let polygonColor = Cesium.Color.fromCssColorString("rgba(244, 75, 72, 0.5)"); // 矩形内部颜色
  if (type == 1) {
    // 限飞区
    polygonColor = Cesium.Color.fromCssColorString("rgba(244, 75, 72, 0.5)"); // 矩形内部颜色
  } else {
    // 飞行区
    polygonColor = Cesium.Color.fromCssColorString("rgba(10, 193, 108, 0.5)"); // 矩形内部颜色
  }
  if (polygonHandler) {
    polygonHandler.destroy();
    polygonHandler = null;
  }
  if (polygonHandler2) {
    polygonHandler2.destroy();
    polygonHandler2 = null;
  }

  let handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
  let handler2 = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
  polygonHandler = handler;
  polygonHandler2 = handler2;
  let polygonPositions = [] as any;
  let polygonEntity = null as any;
  let lineEntity = null as any;
  let index = -1;
  let pointEntityList = [] as any;
  let entityLabelist = [] as any;

  handler.setInputAction((click: any) => {
    /**点击位置笛卡尔坐标 */
    // let cartesian = viewer.scene.pickPosition(click.position);
    if (typeNum.value == 1 || typeNum.value == 3) {
      let ray = viewer.camera.getPickRay(click.position);
      let cartesian = viewer.scene.globe.pick(ray, viewer.scene);
      if (!cartesian) {
        return;
      }
      // return
      let cartographic = Cesium.Cartographic.fromCartesian(cartesian);
      let lng = Cesium.Math.toDegrees(cartographic.longitude);
      let lat = Cesium.Math.toDegrees(cartographic.latitude);
      // console.log(lng, "查看当前点击的经纬度信息", lat);
      polygonPositions.push(cartesian);
      // console.log(polygonPositions, "查看当前点击的经纬度信息123");
      index++;
      let pointEntity = viewer.entities.add({
        name: `polygonPoint`,
        position: new Cesium.CallbackProperty(function () {
          return Cesium.Cartesian3.fromDegrees(lng, lat);
        }, false),
        point: {
          pixelSize: 10.0,
          color: Cesium.Color.WHITE.withAlpha(1),
          outlineWidth: 1,
          outlineColor: Cesium.Color.WHITE,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
        },
        customData: index,
      });
      pointEntityList.push(pointEntity);
      // 创建带背景的Billboard
      const labelImage = createLabelWithBackground(
        "",
        "14px sans-serif",
        "white",
        "rgba(30, 30, 30, 0.7)"
      );
      entityLabelist.push(
        viewer.entities.add({
          position: cartesian,
          billboard: {
            image: labelImage, // 使用生成的图片
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // 水平对齐
            verticalOrigin: Cesium.VerticalOrigin.CENTER, // 垂直对齐
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
            heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          },
          customData: Date.now(),
          labelWidth: 0,
        })
      );

      handler2.setInputAction((event: any) => {
        //   const currentPosition = viewer.scene.pickPosition(event.endPosition);
        let ray = viewer.camera.getPickRay(event.endPosition);
        let currentPosition = viewer.scene.globe.pick(ray, viewer.scene);
        if (polygonPositions.length === 1) {
          polygonPositions.push(currentPosition);
        }
        if (polygonPositions.length >= 2) {
          if (lineEntity === null) {
            lineEntity = viewer.entities.add({
              polyline: {
                positions: new Cesium.CallbackProperty(function () {
                  return polygonPositions;
                }, false),
                material: Cesium.Color.WHITE.withAlpha(0.5),
                width: 5, // 设置线段宽度
                clampToGround: true,
              },
            });
          }
          polygonPositions[polygonPositions.length - 1] = currentPosition;
        }

        // 获取当前鼠标移动对应的左键点击点坐标
        let clickIndex = polygonPositions.length - 2;
        let clickPointForLabel = polygonPositions[clickIndex];

        // 计算当前鼠标移动点和左键点击点的中间位置
        let middlePosition = Cesium.Cartesian3.lerp(
          clickPointForLabel,
          currentPosition,
          0.5,
          new Cesium.Cartesian3()
        );

        // 更新对应的entityLabel的位置为中间位置
        entityLabelist[clickIndex].position = new Cesium.CallbackProperty(
          () => {
            return middlePosition;
          },
          false
        );
        let distance = Cesium.Cartesian3.distance(
          clickPointForLabel,
          currentPosition
        );

        // 创建带背景的Billboard
        const labelImages = createLabelWithBackground(
          `${distance.toFixed(2)}m`,
          "14px sans-serif",
          "white",
          "rgba(30, 30, 30, 0.7)"
        );
        entityLabelist[clickIndex].billboard.image = labelImages;
        entityLabelist[clickIndex].labelWidth = distance.toFixed(2);
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

      // //绘制多边形
      if (polygonPositions.length >= 3) {
        if (polygonEntity === null) {
          polygonEntity = viewer.entities.add({
            polygon: {
              hierarchy: new Cesium.CallbackProperty(function () {
                return new Cesium.PolygonHierarchy(polygonPositions);
              }, false),
              material: polygonColor,
              outline: true,
              outlineColor: Cesium.Color.BLACK,
              outlineWidth: 12,
            },
          });
        }
      }
    }
  }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

  //鼠标右击事件结束
  handler.setInputAction((click: any) => {
    if (typeNum.value == 1 || typeNum.value == 3) {
      // let cartesian = viewer.scene.pickPosition(click.position);
      let ray = viewer.camera.getPickRay(click.position);
      let cartesian = viewer.scene.globe.pick(ray, viewer.scene);
      let cartographic = Cesium.Cartographic.fromCartesian(cartesian);
      let lng = Cesium.Math.toDegrees(cartographic.longitude);
      let lat = Cesium.Math.toDegrees(cartographic.latitude);
      let pointLast = viewer.entities.add({
        id: Date.now(),
        name: `polygonPoint`,
        position: new Cesium.CallbackProperty(function () {
          return Cesium.Cartesian3.fromDegrees(lng, lat);
        }, false),
        point: {
          pixelSize: 10.0,
          color: Cesium.Color.WHITE.withAlpha(1),
          outlineWidth: 1,
          outlineColor: Cesium.Color.WHITE,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
        },
        customData: index + 1,
      });
      pointEntityList.push(pointLast);
      let lineLast = viewer.entities.add({
        polyline: {
          positions: new Cesium.CallbackProperty(function () {
            return [polygonPositions[0], cartesian];
          }, false),
          material: Cesium.Color.WHITE.withAlpha(0.5),
          width: 5, // 设置线段宽度
          clampToGround: true,
        },
      });
      let middlePosition = Cesium.Cartesian3.lerp(
        polygonPositions[0],
        cartesian,
        0.5,
        new Cesium.Cartesian3()
      );
      // console.log(1755, polygonPositions);
      let distance = Cesium.Cartesian3.distance(polygonPositions[0], cartesian);
      // 创建带背景的Billboard
      const labelImage = createLabelWithBackground(
        `${distance.toFixed(2)}m`,
        "14px sans-serif",
        "white",
        "rgba(30, 30, 30, 0.7)"
      );
      entityLabelist.push(
        viewer.entities.add({
          position: middlePosition,
          billboard: {
            image: labelImage, // 使用生成的图片
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // 水平对齐
            verticalOrigin: Cesium.VerticalOrigin.CENTER, // 垂直对齐
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
            heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          },
          customData: Date.now(),
          labelWidth: distance.toFixed(2),
        })
      );
      handler.destroy();
      handler2.destroy();
      let params = {
        polygonEntity: polygonEntity,
        lineEntity: lineEntity,
        pointLast: pointLast,
        lineLast: lineLast,
        polygonPositions: polygonPositions,
        pointEntityList: pointEntityList,
        entityLabelList: entityLabelist,
      };
      callback(params);
    }
  }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);
}
// 多边形 点位使用图片
export function drawPolygonImg(
  type: number,
  viewer: any,
  callback: any,
  callPoint: any
) {
  // callback('123')
  // console.log('用来控制多边形的绘制')
  typeNum.value = type;
  //   let polygonColor = Cesium.Color.RED.withAlpha(0.5); // 矩形内部颜色
  let polygonColor = Cesium.Color.fromCssColorString("rgba(18, 150, 219, 0.5)"); // 矩形内部颜色
  if (polygonHandler) {
    polygonHandler.destroy();
    polygonHandler = null;
  }
  if (polygonHandler2) {
    polygonHandler2.destroy();
    polygonHandler2 = null;
  }

  let handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
  let handler2 = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
  polygonHandler = handler;
  polygonHandler2 = handler2;
  let polygonPositions = [] as any;
  let polygonEntity = null as any;
  let lineEntity = null as any;
  let index = -1;
  let pointEntityList = [] as any;
  let entityLabelist = [] as any;

  handler.setInputAction((click: any) => {
    /**点击位置笛卡尔坐标 */
    // let cartesian = viewer.scene.pickPosition(click.position);
    if (typeNum.value == 1) {
      let ray = viewer.camera.getPickRay(click.position);
      let cartesian = viewer.scene.globe.pick(ray, viewer.scene);
      if (!cartesian) {
        return;
      }
      // return
      let cartographic = Cesium.Cartographic.fromCartesian(cartesian);
      let lng = Cesium.Math.toDegrees(cartographic.longitude);
      let lat = Cesium.Math.toDegrees(cartographic.latitude);
      let points = [lng, lat];
      callPoint(points);
      // console.log(lng, "查看当前点击的经纬度信息", lat);
      polygonPositions.push(cartesian);
      // console.log(polygonPositions, "查看当前点击的经纬度信息123");
      index++;
      let pointEntity = viewer.entities.add({
        name: `polygonPoint`,
        position: new Cesium.CallbackProperty(function () {
          return Cesium.Cartesian3.fromDegrees(lng, lat);
        }, false),
        billboard: {
          width: 30,
          height: 40,
          image: pointYellowImg, // 使用生成的图片
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // 水平对齐
          verticalOrigin: Cesium.VerticalOrigin.CENTER, // 垂直对齐
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        },
        customData: index,
        labelWidth: 0,
      });
      pointEntityList.push(pointEntity);
      // 创建带背景的Billboard
      const labelImage = createLabelWithBackground(
        "",
        "14px sans-serif",
        "white",
        "rgba(30, 30, 30, 0.7)"
      );
      entityLabelist.push(
        viewer.entities.add({
          position: cartesian,
          billboard: {
            image: labelImage, // 使用生成的图片
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // 水平对齐
            verticalOrigin: Cesium.VerticalOrigin.CENTER, // 垂直对齐
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
            heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          },
          customData: Date.now(),
          labelWidth: 0,
        })
      );

      handler2.setInputAction((event: any) => {
        //   const currentPosition = viewer.scene.pickPosition(event.endPosition);
        let ray = viewer.camera.getPickRay(event.endPosition);
        let currentPosition = viewer.scene.globe.pick(ray, viewer.scene);
        if (polygonPositions.length === 1) {
          polygonPositions.push(currentPosition);
        }
        if (polygonPositions.length >= 2) {
          if (lineEntity === null) {
            lineEntity = viewer.entities.add({
              polyline: {
                positions: new Cesium.CallbackProperty(function () {
                  return polygonPositions;
                }, false),
                // material: Cesium.Color.WHITE.withAlpha(0.5),
                material: Cesium.Color.fromCssColorString(
                  "rgba(18, 150, 219, 1)"
                ),
                width: 3, // 设置线段宽度
                clampToGround: true,
              },
            });
          }
          polygonPositions[polygonPositions.length - 1] = currentPosition;
        }

        // 获取当前鼠标移动对应的左键点击点坐标
        let clickIndex = polygonPositions.length - 2;
        let clickPointForLabel = polygonPositions[clickIndex];

        // 计算当前鼠标移动点和左键点击点的中间位置
        let middlePosition = Cesium.Cartesian3.lerp(
          clickPointForLabel,
          currentPosition,
          0.5,
          new Cesium.Cartesian3()
        );

        // 更新对应的entityLabel的位置为中间位置
        entityLabelist[clickIndex].position = new Cesium.CallbackProperty(
          () => {
            return middlePosition;
          },
          false
        );
        let distance = Cesium.Cartesian3.distance(
          clickPointForLabel,
          currentPosition
        );

        // 创建带背景的Billboard
        const labelImages = createLabelWithBackground(
          `${distance.toFixed(2)}m`,
          "14px sans-serif",
          "white",
          "rgba(30, 30, 30, 0.7)"
        );
        entityLabelist[clickIndex].billboard.image = labelImages;
        entityLabelist[clickIndex].labelWidth = distance.toFixed(2);
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

      // //绘制多边形
      if (polygonPositions.length >= 3) {
        if (polygonEntity === null) {
          polygonEntity = viewer.entities.add({
            polygon: {
              hierarchy: new Cesium.CallbackProperty(function () {
                return new Cesium.PolygonHierarchy(polygonPositions);
              }, false),
              material: polygonColor,
              outline: true,
              outlineColor: Cesium.Color.BLACK,
              outlineWidth: 12,
            },
          });
        }
      }
    }
  }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

  //鼠标右击事件结束
  handler.setInputAction((click: any) => {
    if (typeNum.value == 1 || typeNum.value == 3) {
      // let cartesian = viewer.scene.pickPosition(click.position);
      let ray = viewer.camera.getPickRay(click.position);
      let cartesian = viewer.scene.globe.pick(ray, viewer.scene);
      let cartographic = Cesium.Cartographic.fromCartesian(cartesian);
      let lng = Cesium.Math.toDegrees(cartographic.longitude);
      let lat = Cesium.Math.toDegrees(cartographic.latitude);
      const points = [lng, lat];
      callPoint(points);
      let pointLast = viewer.entities.add({
        id: Date.now(),
        name: `polygonPoint`,
        position: new Cesium.CallbackProperty(function () {
          return Cesium.Cartesian3.fromDegrees(lng, lat);
        }, false),
        billboard: {
          width: 30,
          height: 40,
          image: pointYellowImg, // 使用生成的图片
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // 水平对齐
          verticalOrigin: Cesium.VerticalOrigin.CENTER, // 垂直对齐
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        },
        customData: index + 1,
      });
      pointEntityList.push(pointLast);
      let lineLast = viewer.entities.add({
        polyline: {
          positions: new Cesium.CallbackProperty(function () {
            return [polygonPositions[0], cartesian];
          }, false),
          material: Cesium.Color.fromCssColorString("rgba(18, 150, 219, 1)"),
          width: 3, // 设置线段宽度
          clampToGround: true,
        },
      });
      let middlePosition = Cesium.Cartesian3.lerp(
        polygonPositions[0],
        cartesian,
        0.5,
        new Cesium.Cartesian3()
      );
      // console.log(1755, polygonPositions);
      let distance = Cesium.Cartesian3.distance(polygonPositions[0], cartesian);
      // 创建带背景的Billboard
      const labelImage = createLabelWithBackground(
        `${distance.toFixed(2)}m`,
        "14px sans-serif",
        "white",
        "rgba(30, 30, 30, 0.7)"
      );
      entityLabelist.push(
        viewer.entities.add({
          position: middlePosition,
          billboard: {
            image: labelImage, // 使用生成的图片
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // 水平对齐
            verticalOrigin: Cesium.VerticalOrigin.CENTER, // 垂直对齐
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
            heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          },
          customData: Date.now(),
          labelWidth: distance.toFixed(2),
        })
      );
      handler.destroy();
      handler2.destroy();
      let params = {
        polygonEntity: polygonEntity,
        lineEntity: lineEntity,
        pointLast: pointLast,
        lineLast: lineLast,
        polygonPositions: polygonPositions,
        pointEntityList: pointEntityList,
        entityLabelList: entityLabelist,
      };
      callback(params);
    }
  }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);
}
// 使用Canvas生成带背景的Billboard
function createLabelWithBackground(
  text: any,
  font: any,
  textColor: any,
  bgColor: any,
  paddings = 5
) {
  let padding = text ? paddings : 0;

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d") as any;

  // 测量文字尺寸
  ctx.font = font;
  const textWidth = ctx.measureText(text).width;
  const fontSize = parseInt(font);

  // 设置Canvas尺寸（文字+内边距）
  canvas.width = textWidth + padding * 2;
  canvas.height = fontSize + padding * 2;

  // 绘制圆角背景
  ctx.fillStyle = bgColor;
  const borderRadius = 4;
  ctx.beginPath();
  ctx.roundRect(0, 0, canvas.width, canvas.height, borderRadius);
  ctx.fill();

  // 绘制文字
  ctx.font = font;
  ctx.fillStyle = textColor;
  ctx.textBaseline = "middle";
  ctx.fillText(text, padding, canvas.height / 2);

  return canvas.toDataURL(); // 返回图片URL
}
// 还原
export function refreshPolygon(entityObjPolygonObj: any) {
  entityObjPolygonObj.point.map((item: any) => {
    item.point.pixelSize = 2;
    item.color = Cesium.Color.WHITE.withAlpha(0.5);
  });
  entityObjPolygonObj.line.map((item: any) => {
    item.polyline.width = 3;
  });
  const labelImage = createLabelWithBackground(
    `${entityObjPolygonObj.name}`,
    "14px sans-serif",
    "white",
    "rgba(30, 30, 30, 0.0)"
  );
  entityObjPolygonObj.namelist.map((item: any) => {
    item.billboard.image = labelImage;
  });
}
//移动多边形的各个边
export function movePolygon(
  entityObjPolygonObj: any,
  viewer: any,
  callback: any
) {
  let handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
  entityObjPolygonObj.point.map((item: any) => {
    item.point.pixelSize = 10;
    item.color = Cesium.Color.WHITE.withAlpha(0.8);
  });
  entityObjPolygonObj.line.map((item: any) => {
    item.polyline.width = 5;
  });
  const labelImage = createLabelWithBackground(
    `${entityObjPolygonObj.name}`,
    "14px sans-serif",
    "white",
    "rgba(30, 30, 30, 0.7)"
  );
  entityObjPolygonObj.namelist.map((item: any) => {
    item.billboard.image = labelImage;
  });
  handler.setInputAction((events: any) => {
    let pickedObject = viewer.scene.pick(events.position);
    console.log(pickedObject, "查看当前点击的实体是那个");
    if (
      pickedObject &&
      pickedObject.id &&
      pickedObject.id.name === "polygonPoint"
    ) {
      handler.setInputAction((event: any) => {
        let ray = viewer.camera.getPickRay(event.endPosition);
        let currentPosition = viewer.scene.globe.pick(ray, viewer.scene);
        let pointIndex = pickedObject.id.customData;
        if (pointIndex == 1) {
          // 第一个点
          // let middlePosition = Cesium.Cartesian3.lerp(entityObjPolygonObj.polygonPositions[0], entityObjPolygonObj.polygonPositions[1], 0.5, new Cesium.Cartesian3());
        }
        if (pointIndex == entityObjPolygonObj.point.length) {
          // 最后一个点
        }
        if (pointIndex != 1 && pointIndex != entityObjPolygonObj.point.length) {
          // 中间点位
        }
        entityObjPolygonObj.polygonPositions[pointIndex - 1] = currentPosition;
        entityObjPolygonObj.polygon[0].polygon.heirarchy =
          new Cesium.CallbackProperty(() => {
            return new Cesium.PolygonHierarchy(
              entityObjPolygonObj.polygonPositions
            );
          }, false);
        entityObjPolygonObj.line[0].polyline.positions =
          new Cesium.CallbackProperty(() => {
            return entityObjPolygonObj.polygonPositions;
          }, false);
        entityObjPolygonObj.point[pointIndex - 1].position =
          new Cesium.CallbackProperty(() => {
            return currentPosition;
          }, false);

        handler.setInputAction((clickEvent: any) => {
          handler.destroy();
          //缺少回调的逻辑用于移动后还能拿到最新的点，可多次移动
          callback(entityObjPolygonObj);
        }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
    }
  }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
}
//移动多边形的各个边
export function moveGisPolygon(
  entityObjPolygonObj: any,
  viewer: any,
  callback: any,
  callPoint: any
) {
  let handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
  entityObjPolygonObj.point.map((item: any) => {
    item.point.pixelSize = 10;
    item.color = Cesium.Color.WHITE.withAlpha(0.8);
  });
  entityObjPolygonObj.line.map((item: any) => {
    item.polyline.width = 5;
  });
  const labelImage = createLabelWithBackground(
    `${entityObjPolygonObj.name}`,
    "14px sans-serif",
    "white",
    "rgba(30, 30, 30, 0.7)"
  );
  entityObjPolygonObj.namelist.map((item: any) => {
    item.billboard.image = labelImage;
  });
  handler.setInputAction((events: any) => {
    let pickedObject = viewer.scene.pick(events.position);
    // console.log(pickedObject, "查看当前点击的实体是那个");
    if (
      pickedObject &&
      pickedObject.id &&
      pickedObject.id.name === "polygonPoint"
    ) {
      handler.setInputAction((event: any) => {
        let ray = viewer.camera.getPickRay(event.endPosition);
        let currentPosition = viewer.scene.globe.pick(ray, viewer.scene);
        let pointIndex = pickedObject.id.customData;
        let cartographic = Cesium.Cartographic.fromCartesian(currentPosition);
        let lng = Cesium.Math.toDegrees(cartographic.longitude);
        let lat = Cesium.Math.toDegrees(cartographic.latitude);
        let points = [lng, lat];
        let params1 = {
          points,
          pointIndex,
        };
        callPoint(params1);
        if (pointIndex == 1) {
          // 第一个点
        }
        if (pointIndex == entityObjPolygonObj.point.length) {
          // 最后一个点
        }
        if (pointIndex != 1 && pointIndex != entityObjPolygonObj.point.length) {
          // 中间点位
        }
        entityObjPolygonObj.polygonPositions[pointIndex - 1] = currentPosition;
        entityObjPolygonObj.polygon[0].polygon.heirarchy =
          new Cesium.CallbackProperty(() => {
            return new Cesium.PolygonHierarchy(
              entityObjPolygonObj.polygonPositions
            );
          }, false);
        entityObjPolygonObj.line[0].polyline.positions =
          new Cesium.CallbackProperty(() => {
            return entityObjPolygonObj.polygonPositions;
          }, false);
        entityObjPolygonObj.point[pointIndex - 1].position =
          new Cesium.CallbackProperty(() => {
            return currentPosition;
          }, false);

        handler.setInputAction((clickEvent: any) => {
          handler.destroy();
          //缺少回调的逻辑用于移动后还能拿到最新的点，可多次移动
          callback(entityObjPolygonObj);
        }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
    }
  }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
}

// 绘制 多边形列表
export function drawListPolygon(viewer: any, list: any, callback: any) {
  let arrAll = [] as any;
  if (list && list.length > 0) {
    list.forEach((listItem: any) => {
      let entityList = {
        point: [] as any,
        line: [] as any,
        polygon: [] as any,
        namelist: [] as any,
        id: listItem.id,
        name: listItem.name,
        polygonPositions: [] as any, // 各个点的位置
      } as any;
      const item = listItem.list;
      entityList.polygonPositions = item.point;
      // 点
      if (item.pointList && item.pointList.length > 0) {
        const types = item.type;
        let pointColor =
          types == 3
            ? Cesium.Color.fromCssColorString("rgba(0, 97, 52, 1)")
            : Cesium.Color.fromCssColorString("rgba(143, 0, 0, 1)"); // 矩形内部颜色
        if (!item.is_use) {
          pointColor = Cesium.Color.fromCssColorString(
            "rgba(146, 146, 146, 1)"
          );
        }
        item.pointList.forEach((pointItem: any) => {
          let pointEntity = viewer.entities.add({
            name: `polygonPoint`,
            position: pointItem.point,
            id: listItem.id + "polygonPoint" + pointItem.sort,
            point: {
              pixelSize: 5.0,
              color: pointColor,
              outlineWidth: 1,
              outlineColor: pointColor,
              heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
              disableDepthTestDistance: Number.POSITIVE_INFINITY,
            },
            customData: pointItem.sort,
          });
          entityList.point.push(pointEntity);
        });
      }
      // 线
      if (item.line && item.line.length > 0) {
        const types = item.type;
        let lineColor =
          types == 3
            ? Cesium.Color.fromCssColorString("rgba(10, 193, 108, 1)")
            : Cesium.Color.fromCssColorString("rgba(244, 75, 72, 1)"); // 矩形内部颜色
        if (!item.is_use) {
          lineColor = Cesium.Color.fromCssColorString("rgba(146, 146, 146, 1)");
        }
        // item.line.forEach((lineItem: any) => {
        //   let lineLast = viewer.entities.add({
        //     polyline: {
        //       positions: lineItem,
        //       material: lineColor,
        //       width: 3, // 设置线段宽度
        //       clampToGround: true,
        //     },
        //   });
        //   entityList.line.push(lineLast);
        // });
        let lineLast = viewer.entities.add({
          polyline: {
            positions: new Cesium.CallbackProperty(function () {
              return item.point;
            }, false),
            material: lineColor,
            width: 3, // 设置线段宽度
            clampToGround: true,
          },
        });
        entityList.line.push(lineLast);
      }
      //   矩形
      if (item.polygon && item.polygon.length > 0) {
        item.polygon.forEach((polygonItem: any) => {
          const types = polygonItem.type;
          let polygonColor =
            types == 3
              ? Cesium.Color.fromCssColorString("rgba(10, 193, 108, 0.5)")
              : Cesium.Color.fromCssColorString("rgba(244, 75, 72, 0.5)"); // 矩形内部颜色
          //   let polygonColor =
          //     types == 3
          //       ? Cesium.Color.GREEN.withAlpha(0.5)
          //       : Cesium.Color.RED.withAlpha(0.5); // 矩形内部颜色
          if (!item.is_use) {
            polygonColor = Cesium.Color.fromCssColorString(
              "rgba(146, 146, 146, 0.5)"
            );
          }
          let polygonEntity = viewer.entities.add({
            id: polygonItem.id,
            typeEntity: "polygon",
            polygon: {
              hierarchy: new Cesium.CallbackProperty(function () {
                return new Cesium.PolygonHierarchy(polygonItem.list);
              }, false),
              material: polygonColor,
              outline: true,
              outlineColor: Cesium.Color.BLACK,
              outlineWidth: 12,
            },
          });
          entityList.polygon.push(polygonEntity);
        });
      }
      //   名称
      if (item.nameList && item.nameList.length > 0) {
        item.nameList.forEach((pointItem: any) => {
          const labelImage = createLabelWithBackground(
            `${pointItem.name}`,
            "18px sans-serif",
            "white",
            "rgba(30, 30, 30, 0.0)"
          );
          let names = viewer.entities.add({
            position: pointItem.point,
            billboard: {
              image: labelImage, // 使用生成的图片
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // 水平对齐
              verticalOrigin: Cesium.VerticalOrigin.CENTER, // 垂直对齐
              disableDepthTestDistance: Number.POSITIVE_INFINITY,
              heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
            },
          });
          entityList.namelist.push(names);
        });
      }
      arrAll.push(entityList);
    });
  }
  callback(arrAll);
}
// 绘制 多边形列表 用于大屏
export function drawGisListPolygonAll(viewer: any, list: any, callback: any) {
  let arrAll = [] as any;
  if (list && list.length > 0) {
    // console.log(858, list);

    list.forEach((listItem: any) => {
      let entityList = {
        point: [] as any,
        line: [] as any,
        polygon: [] as any,
        namelist: [] as any,
        rulesList: [] as any,
        id: listItem.id,
        name: listItem.name,
        polygonPositions: [] as any, // 各个点的位置
      } as any;
      const item = listItem.list;
      entityList.polygonPositions = item.point;

      // 线
      if (item.line && item.line.length > 0) {
        let lineColor = Cesium.Color.fromCssColorString(
          "rgba(10, 193, 108, 1)"
        );
        if (item.pointList && item.pointList.length > 0) {
          if (item.pointList[0].pointColor) {
            lineColor = Cesium.Color.fromCssColorString(
              item.pointList[0].pointColor
            );
          }
        }
        let lineLast = viewer.entities.add({
          polyline: {
            positions: new Cesium.CallbackProperty(function () {
              // return item.point;
              let newPositions = item.point.concat(item.point[0]);
              return newPositions;
            }, false),
            material: lineColor,
            width: 2, // 设置线段宽度
            clampToGround: true,
          },
        });
        entityList.line.push(lineLast);
      }
      //   矩形
      if (item.polygon && item.polygon.length > 0) {
        item.polygon.forEach((polygonItem: any) => {
          let polygonColor = polygonItem.polygonColor
            ? Cesium.Color.fromCssColorString(polygonItem.polygonColor)
            : Cesium.Color.fromCssColorString("rgba(10, 193, 108, 0.2)");
          let polygonEntity = viewer.entities.add({
            id: polygonItem.id + "polygon",
            typeEntity: "polygon",
            polygon: {
              hierarchy: new Cesium.CallbackProperty(function () {
                return new Cesium.PolygonHierarchy(polygonItem.list);
              }, false),
              material: polygonColor,
              outline: true,
              outlineColor: Cesium.Color.BLACK,
              outlineWidth: 12,
            },
          });
          entityList.polygon.push(polygonEntity);
        });
      }
      //   名称
      if (item.nameList && item.nameList.length > 0) {
        item.nameList.forEach((pointItem: any) => {
          const labelImage = createLabelWithBackground(
            `${pointItem.name}`,
            "18px sans-serif",
            "white",
            "rgba(30, 30, 30, 0.0)"
          );
          let names = viewer.entities.add({
            position: pointItem.point,
            billboard: {
              image: labelImage, // 使用生成的图片
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // 水平对齐
              verticalOrigin: Cesium.VerticalOrigin.CENTER, // 垂直对齐
              disableDepthTestDistance: Number.POSITIVE_INFINITY,
              heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
              // 优化：根据相机距离动态调整标签大小
              // 参数说明：NearFarScalar(近距离, 近距离缩放, 远距离, 远距离缩放)
              // 距离 1000 米时：缩放 1.0 倍（原始大小）
              // 距离 50000 米时：缩放 0.4 倍（缩小）
              scaleByDistance: new Cesium.NearFarScalar(1000, 1.0, 50000, 0.4),
              // 添加距离显示条件：相机高度在 0-50000 米之间显示标签
              // 当相机高度超过 50000 米（地图缩放很小）时，标签会隐藏
              distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 50000),
            },
          });
          entityList.namelist.push(names);
        });
      }
      arrAll.push(entityList);
    });
  }
  callback(arrAll);
}
// 绘制 多边形列表
export function drawGisListPolygons(viewer: any, list: any, callback: any) {
  let arrAll = [] as any;
  if (list && list.length > 0) {
    // console.log(858, list);

    list.forEach((listItem: any) => {
      let entityList = {
        point: [] as any,
        line: [] as any,
        polygon: [] as any,
        namelist: [] as any,
        rulesList: [] as any,
        id: listItem.id,
        name: listItem.name,
        polygonPositions: [] as any, // 各个点的位置
      } as any;
      const item = listItem.list;
      entityList.polygonPositions = item.point;
      // 点
      if (item.pointList && item.pointList.length > 0) {
        item.pointList.forEach((pointItem: any) => {
          // let pointColor = pointItem.pointColor
          //   ? Cesium.Color.fromCssColorString(pointItem.pointColor)
          //   : Cesium.Color.fromCssColorString("rgba(0, 97, 52, 1)");
          // let pointEntity = viewer.entities.add({
          //   name: `polygonPoint`,
          //   typeEntity: "polygon",
          //   position: pointItem.point,
          //   id: listItem.id + "polygonPoint" + pointItem.sort,
          //   point: {
          //     pixelSize: 5.0,
          //     color: pointColor,
          //     outlineWidth: 1,
          //     outlineColor: pointColor,
          //     heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          //     disableDepthTestDistance: Number.POSITIVE_INFINITY,
          //   },
          //   customData: pointItem.sort,
          // });
          // entityList.point.push(pointEntity);
        });
      }
      // 线
      if (item.line && item.line.length > 0) {
        let lineColor = Cesium.Color.fromCssColorString(
          "rgba(10, 193, 108, 1)"
        );
        if (item.pointList && item.pointList.length > 0) {
          if (item.pointList[0].pointColor) {
            lineColor = Cesium.Color.fromCssColorString(
              item.pointList[0].pointColor
            );
          }
        }
        let lineLast = viewer.entities.add({
          polyline: {
            positions: new Cesium.CallbackProperty(function () {
              // return item.point;
              let newPositions = item.point.concat(item.point[0]);
              return newPositions;
            }, false),
            material: lineColor,
            width: 2, // 设置线段宽度
            clampToGround: true,
          },
        });
        entityList.line.push(lineLast);
      }
      //   矩形
      if (item.polygon && item.polygon.length > 0) {
        item.polygon.forEach((polygonItem: any) => {
          let polygonColor = polygonItem.polygonColor
            ? Cesium.Color.fromCssColorString(polygonItem.polygonColor)
            : Cesium.Color.fromCssColorString("rgba(10, 193, 108, 0.2)");
          let polygonEntity = viewer.entities.add({
            id: polygonItem.id,
            typeEntity: "polygon",
            polygon: {
              hierarchy: new Cesium.CallbackProperty(function () {
                return new Cesium.PolygonHierarchy(polygonItem.list);
              }, false),
              material: polygonColor,
              outline: true,
              outlineColor: Cesium.Color.BLACK,
              outlineWidth: 12,
            },
          });
          entityList.polygon.push(polygonEntity);
        });
      }
      //   名称
      if (item.nameList && item.nameList.length > 0) {
        item.nameList.forEach((pointItem: any) => {
          const labelImage = createLabelWithBackground(
            `${pointItem.name}`,
            "18px sans-serif",
            "white",
            "rgba(30, 30, 30, 0.0)"
          );
          let names = viewer.entities.add({
            position: pointItem.point,
            billboard: {
              image: labelImage, // 使用生成的图片
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // 水平对齐
              verticalOrigin: Cesium.VerticalOrigin.CENTER, // 垂直对齐
              disableDepthTestDistance: Number.POSITIVE_INFINITY,
              heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
              // 优化：根据相机距离动态调整标签大小
              // 参数说明：NearFarScalar(近距离, 近距离缩放, 远距离, 远距离缩放)
              // 距离 1000 米时：缩放 1.0 倍（原始大小）
              // 距离 50000 米时：缩放 0.4 倍（缩小）
              scaleByDistance: new Cesium.NearFarScalar(1000, 1.0, 50000, 0.4),
              // 添加距离显示条件：相机高度在 0-50000 米之间显示标签
              distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 50000),
            },
          });
          entityList.namelist.push(names);
        });
      }
      // 规则图标
      if (item.nameList && item.nameList.length > 0) {
        item.nameList.forEach((pointItem: any) => {
          const iconList = pointItem.iconList;
          const iconPoint = pointItem.point;
          if (iconList && iconList.length > 0) {
            iconList.forEach((icons: any, index: any) => {
              let labelImage = compareImg4;
              if (icons == 31) {
                // 聚集
                labelImage = compareImg1;
              }
              if (icons == 32) {
                // 裸土
                labelImage = compareImg2;
              }
              if (icons == 36) {
                // 人
                labelImage = compareImg5;
              }
              if (icons == 35) {
                // 牛羊
                labelImage = compareImg3;
              }
              let names = viewer.entities.add({
                id: pointItem.id + "rules" + icons,
                position: iconPoint,
                billboard: {
                  image: labelImage, // 使用生成的图片
                  horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // 水平对齐
                  verticalOrigin: Cesium.VerticalOrigin.CENTER, // 垂直对齐
                  disableDepthTestDistance: Number.POSITIVE_INFINITY,
                  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  width: 20,
                  height: 20,
                  pixelOffset: new Cesium.Cartesian2(25 * index, 25),
                },
                properties: { ...pointItem, currentRules: icons },
              });
              entityList.rulesList.push(names);
            });
          }
          let times = viewer.entities.add({
            id: pointItem.timeId,
            position: iconPoint,
            billboard: {
              image: timeImg, // 使用生成的图片
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // 水平对齐
              verticalOrigin: Cesium.VerticalOrigin.CENTER, // 垂直对齐
              disableDepthTestDistance: Number.POSITIVE_INFINITY,
              heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
              width: 20,
              height: 20,
              // scaleByDistance: new Cesium.NearFarScalar(3000, 1, 100000, 0.3),
              pixelOffset: new Cesium.Cartesian2(-25, 25),
            },
            properties: { ...pointItem, currentTime: pointItem.times },
          });
          entityList.rulesList.push(times);
          let infos = viewer.entities.add({
            id: pointItem.infoId,
            position: pointItem.lngPoint,
            billboard: {
              image: infoImg, // 使用生成的图片
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // 水平对齐
              verticalOrigin: Cesium.VerticalOrigin.CENTER, // 垂直对齐
              disableDepthTestDistance: Number.POSITIVE_INFINITY,
              heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
              width: 20,
              height: 20,
              // scaleByDistance: new Cesium.NearFarScalar(3000, 1, 100000, 0.3),
              // pixelOffset: new Cesium.Cartesian2(0, 50),
            },
            properties: { ...pointItem, currentInfo: pointItem.id },
          });
          entityList.rulesList.push(infos);
        });
      }

      arrAll.push(entityList);
    });
  }
  callback(arrAll);
}
// 绘制 多边形列表
export function drawGisListPolygon(viewer: any, list: any, callback: any) {
  let arrAll = [] as any;
  if (list && list.length > 0) {
    list.forEach((listItem: any) => {
      let entityList = {
        point: [] as any,
        line: [] as any,
        polygon: [] as any,
        namelist: [] as any,
        id: listItem.id,
        name: listItem.name,
        polygonPositions: [] as any, // 各个点的位置
      } as any;
      const item = listItem.list;
      entityList.polygonPositions = item.point;
      // 点
      if (item.pointList && item.pointList.length > 0) {
        item.pointList.forEach((pointItem: any) => {
          let pointColor = pointItem.pointColor
            ? Cesium.Color.fromCssColorString(pointItem.pointColor)
            : Cesium.Color.fromCssColorString("rgba(0, 97, 52, 1)");
          let pointEntity = viewer.entities.add({
            name: `polygonPoint`,
            typeEntity: "polygon",
            position: pointItem.point,
            id: listItem.id + "polygonPoint" + pointItem.sort,
            point: {
              pixelSize: 5.0,
              color: pointColor,
              outlineWidth: 1,
              outlineColor: pointColor,
              heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
              disableDepthTestDistance: Number.POSITIVE_INFINITY,
            },
            customData: pointItem.sort,
          });
          entityList.point.push(pointEntity);
        });
      }
      // 线
      if (item.line && item.line.length > 0) {
        let lineColor = Cesium.Color.fromCssColorString(
          "rgba(10, 193, 108, 1)"
        );
        if (item.pointList && item.pointList.length > 0) {
          if (item.pointList[0].pointColor) {
            lineColor = Cesium.Color.fromCssColorString(
              item.pointList[0].pointColor
            );
          }
        }
        let lineLast = viewer.entities.add({
          polyline: {
            positions: new Cesium.CallbackProperty(function () {
              // return item.point;
              let newPositions = item.point.concat(item.point[0]);
              return newPositions;
            }, false),
            material: lineColor,
            width: 3, // 设置线段宽度
            clampToGround: true,
          },
        });
        entityList.line.push(lineLast);
      }
      //   矩形
      if (item.polygon && item.polygon.length > 0) {
        item.polygon.forEach((polygonItem: any) => {
          let polygonColor = polygonItem.polygonColor
            ? Cesium.Color.fromCssColorString(polygonItem.polygonColor)
            : Cesium.Color.fromCssColorString("rgba(10, 193, 108, 0.5)");
          let polygonEntity = viewer.entities.add({
            id: polygonItem.id,
            typeEntity: "polygon",
            polygon: {
              hierarchy: new Cesium.CallbackProperty(function () {
                return new Cesium.PolygonHierarchy(polygonItem.list);
              }, false),
              material: polygonColor,
              outline: true,
              outlineColor: Cesium.Color.BLACK,
              outlineWidth: 12,
            },
          });
          entityList.polygon.push(polygonEntity);
        });
      }
      //   名称
      if (item.nameList && item.nameList.length > 0) {
        item.nameList.forEach((pointItem: any) => {
          const labelImage = createLabelWithBackground(
            `${pointItem.name}`,
            "18px sans-serif",
            "white",
            "rgba(30, 30, 30, 0.0)"
          );
          let names = viewer.entities.add({
            position: pointItem.point,
            billboard: {
              image: labelImage, // 使用生成的图片
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // 水平对齐
              verticalOrigin: Cesium.VerticalOrigin.CENTER, // 垂直对齐
              disableDepthTestDistance: Number.POSITIVE_INFINITY,
              heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
            },
          });
          entityList.namelist.push(names);
        });
      }
      arrAll.push(entityList);
    });
  }
  callback(arrAll);
}
// 绘制 圆形 列表
export function drawListCircle(viewer: any, list: any, callback: any) {
  let arrAll = [] as any;

  if (list && list.length > 0) {
    list.forEach((listItem: any) => {
      let entityList = {
        circle: [] as any,
        namelist: [] as any,
        id: listItem.id,
        name: listItem.name,
      };
      const item = listItem.list;
      if (item.circle && item.circle.length > 0) {
        item.circle.forEach((pointItem: any) => {
          const types = pointItem.type;

          let circleBg =
            types == 4
              ? Cesium.Color.fromCssColorString("rgba(10, 193, 108, 0.5)")
              : Cesium.Color.fromCssColorString("rgba(244, 75, 72, 0.5)"); // 矩形内部颜色
          if (!item.is_use) {
            circleBg = Cesium.Color.fromCssColorString(
              "rgba(146, 146, 146, 0.5)"
            );
          }
          // console.log(1297, pointItem.point, pointItem);
          if (pointItem.radius) {
            let entity = viewer.entities.add({
              position: pointItem.point,
              name: "circle",
              typeEntity: "circle",
              id: pointItem.pointId,
              ellipse: {
                semiMinorAxis: pointItem.radius,
                semiMajorAxis: pointItem.radius,
                outline: true,
                material: circleBg,
                outlineColor: Cesium.Color.WHITE,
                outlineWidth: 5,
                // clampToGround: true,
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                disableDepthTestDistance: Number.POSITIVE_INFINITY,
              },
            });
            entityList.circle.push(entity);
            const labelImage = createLabelWithBackground(
              `${pointItem.name}`,
              "18px sans-serif",
              "white",
              "rgba(30, 30, 30, 0.0)"
            );
            let names = viewer.entities.add({
              position: pointItem.point,
              billboard: {
                image: labelImage, // 使用生成的图片
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // 水平对齐
                verticalOrigin: Cesium.VerticalOrigin.CENTER, // 垂直对齐
                disableDepthTestDistance: Number.POSITIVE_INFINITY,
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
              },
            });
            entityList.namelist.push(names);
          }
        });
      }
      arrAll.push(entityList);
    });
  }
  callback(arrAll);
}
// 圆形 实体改变
export function refreshCircle(entityObjPolygonObj: any, type: any) {  
  if (type == 1) {
    // 选中
    const labelImage = createLabelWithBackground(
      `${entityObjPolygonObj.name}`,
      "14px sans-serif",
      "white",
      "rgba(30, 30, 30, 0.7)"
    );
    entityObjPolygonObj.namelist.map((item: any) => {
      item.billboard.image = labelImage;
    });
  } else {
    // 未选中
    const labelImage = createLabelWithBackground(
      `${entityObjPolygonObj.name}`,
      "14px sans-serif",
      "white",
      "rgba(30, 30, 30, 0.0)"
    );
    entityObjPolygonObj.namelist.map((item: any) => {
      item.billboard.image = labelImage;
    });
  }
}

// 移动圆形 - 调整半径
export function moveCircle(
  entityObjCircleObj: any,
  viewer: any,
  callback: any
) {
  let handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
  
  // 高亮显示名称
  const labelImage = createLabelWithBackground(
    `${entityObjCircleObj.name}`,
    "14px sans-serif",
    "white",
    "rgba(30, 30, 30, 0.7)"
  );
  entityObjCircleObj.namelist.map((item: any) => {
    item.billboard.image = labelImage;
  });

  // 获取圆形实体和圆心位置
  if (!entityObjCircleObj.circle || entityObjCircleObj.circle.length === 0) {
    return;
  }

  const circleEntity = entityObjCircleObj.circle[0];
  
  // 获取圆心位置
  let centerPosition = null as any;
  if (circleEntity.position._value) {
    centerPosition = circleEntity.position._value;
  } else if (circleEntity.position.getValue) {
    centerPosition = circleEntity.position.getValue(Cesium.JulianDate.now());
  } else {
    centerPosition = circleEntity.position;
  }
  
  const cartographic = Cesium.Cartographic.fromCartesian(centerPosition);
  const centerLng = Cesium.Math.toDegrees(cartographic.longitude);
  const centerLat = Cesium.Math.toDegrees(cartographic.latitude);
  
  // 获取当前半径
  let currentRadius = 0;
  if (circleEntity.ellipse.semiMajorAxis._value) {
    currentRadius = circleEntity.ellipse.semiMajorAxis._value;
  } else if (circleEntity.ellipse.semiMajorAxis.getValue) {
    currentRadius = circleEntity.ellipse.semiMajorAxis.getValue(Cesium.JulianDate.now());
  } else {
    currentRadius = circleEntity.ellipse.semiMajorAxis;
  }
  
  // 计算半径控制点的初始位置
  const radiusPointPosition = calculateNewLocation3(
    centerLng,
    centerLat,
    currentRadius,
    90
  );
  
  // 使用变量存储半径控制点位置，便于动态更新
  let radiusPointPos = Cesium.Cartesian3.fromDegrees(
    radiusPointPosition.newLongitude,
    radiusPointPosition.newLatitude
  );
  
  // 添加圆心控制点
  let centerPoint = viewer.entities.add({
    name: `circleCenter`,
    position: centerPosition,
    point: {
      pixelSize: 10.0,
      color: Cesium.Color.WHITE.withAlpha(1),
      outlineWidth: 2,
      outlineColor: Cesium.Color.BLUE,
      heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
      disableDepthTestDistance: Number.POSITIVE_INFINITY,
    },
  });

  // 使用 Cartesian2 存储鼠标屏幕坐标
  let mousePosition = new Cesium.Cartesian2();
  let isDragging = false;
  
  // 创建 CallbackProperty 用于动态更新控制点位置
  let radiusPointPositionProperty = new Cesium.CallbackProperty(function() {
    if (isDragging) {
      // 拖动时，根据鼠标位置计算新的控制点位置
      let position = viewer.scene.camera.pickEllipsoid(mousePosition);
      if (!position) {
        position = viewer.scene.globe.pick(
          viewer.camera.getPickRay(mousePosition),
          viewer.scene
        );
      }
      if (position) {
        return position;
      }
    }
    return radiusPointPos;
  }, false);

  // 添加半径控制点（在圆的右侧）
  let radiusPoint = viewer.entities.add({
    name: `circleRadiusPoint`,
    position: radiusPointPositionProperty,
    point: {
      pixelSize: new Cesium.CallbackProperty(function () {
        return isDragging ? 15.0 : 10.0;
      }, false),
      color: new Cesium.CallbackProperty(function () {
        return isDragging 
          ? Cesium.Color.YELLOW.withAlpha(1) 
          : Cesium.Color.WHITE.withAlpha(1);
      }, false),
      outlineWidth: 2,
      outlineColor: Cesium.Color.BLUE,
      heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
      disableDepthTestDistance: Number.POSITIVE_INFINITY,
    },
  });

  // 添加半径指示线
  let radiusLine = viewer.entities.add({
    polyline: {
      positions: new Cesium.CallbackProperty(function () {
        let endPos = radiusPointPositionProperty.getValue(Cesium.JulianDate.now());
        return [centerPosition, endPos];
      }, false),
      material: Cesium.Color.WHITE.withAlpha(0.8),
      width: 3,
      clampToGround: true,
    },
  });

  // 添加半径标签
  let radiusLabel = viewer.entities.add({
    position: new Cesium.CallbackProperty(function () {
      let endPos = radiusPointPositionProperty.getValue(Cesium.JulianDate.now());
      return Cesium.Cartesian3.lerp(
        centerPosition,
        endPos,
        0.5,
        new Cesium.Cartesian3()
      );
    }, false),
    billboard: {
      image: new Cesium.CallbackProperty(function () {
        return createLabelWithBackground(
          `${currentRadius.toFixed(2)}m`,
          "14px sans-serif",
          "white",
          "rgba(30, 30, 30, 0.7)"
        );
      }, false),
      horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
      verticalOrigin: Cesium.VerticalOrigin.CENTER,
      disableDepthTestDistance: Number.POSITIVE_INFINITY,
      heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
    },
  });

  // 鼠标按下事件
  handler.setInputAction((click: any) => {
    let pickedObject = viewer.scene.pick(click.position);
    
    if (
      pickedObject &&
      pickedObject.id &&
      pickedObject.id.name === "circleRadiusPoint"
    ) {
      isDragging = true;
      viewer.scene.screenSpaceCameraController.enableRotate = false;
      Cesium.Cartesian2.clone(click.position, mousePosition);
    }
  }, Cesium.ScreenSpaceEventType.LEFT_DOWN);

  // 鼠标移动事件
  handler.setInputAction((movement: any) => {
    if (isDragging) {
      Cesium.Cartesian2.clone(movement.endPosition, mousePosition);
      
      // 计算新半径
      let position = viewer.scene.camera.pickEllipsoid(mousePosition);
      if (!position) {
        position = viewer.scene.globe.pick(
          viewer.camera.getPickRay(mousePosition),
          viewer.scene
        );
      }
      
      if (position) {
        const newRadius = Cesium.Cartesian3.distance(centerPosition, position);
        const finalRadius = Math.max(1, Math.min(newRadius, 50000));
        
        // 更新圆形半径
        circleEntity.ellipse.semiMajorAxis = finalRadius;
        circleEntity.ellipse.semiMinorAxis = finalRadius;
        currentRadius = finalRadius;
      }
    }
  }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

  // 鼠标抬起事件
  handler.setInputAction((click: any) => {
    if (isDragging) {
      isDragging = false;
      viewer.scene.screenSpaceCameraController.enableRotate = true;
      
      // 固定控制点位置
      let position = viewer.scene.camera.pickEllipsoid(click.position);
      if (!position) {
        position = viewer.scene.globe.pick(
          viewer.camera.getPickRay(click.position),
          viewer.scene
        );
      }
      
      if (position) {
        // 计算最终半径
        const newRadius = Cesium.Cartesian3.distance(centerPosition, position);
        const finalRadius = Math.max(1, Math.min(newRadius, 50000));
        currentRadius = finalRadius;
        
        // 更新控制点位置到正东方向
        const newRadiusPointPosition = calculateNewLocation3(
          centerLng,
          centerLat,
          finalRadius,
          90
        );
        radiusPointPos = Cesium.Cartesian3.fromDegrees(
          newRadiusPointPosition.newLongitude,
          newRadiusPointPosition.newLatitude
        );
      }
    }
  }, Cesium.ScreenSpaceEventType.LEFT_UP);

  // 右键结束编辑
  handler.setInputAction((clickEvent: any) => {
    // 清理控制点和辅助线
    viewer.entities.remove(centerPoint);
    viewer.entities.remove(radiusPoint);
    viewer.entities.remove(radiusLine);
    viewer.entities.remove(radiusLabel);
    
    handler.destroy();
    
    // 回调返回更新后的数据
    const updatedData = {
      ...entityObjCircleObj,
      radius: currentRadius.toFixed(2),
      centerPosition: [centerLng, centerLat],
    };
    callback(updatedData);
  }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);
}
// 绘制 圆形
export function drawCircle(type: number, viewer: any, callback: any) {
  if (circleHandler) {
    circleHandler.destroy();
    circleHandler = null;
  }
  let handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
  circleHandler = handler;
  typeNum.value = type;
  //   let circleBg = Cesium.Color.GREEN.withAlpha(0.5);
  let circleBg = Cesium.Color.fromCssColorString("rgba(10, 193, 108, 0.5)");
  if (type == 2) {
    circleBg = Cesium.Color.fromCssColorString("rgba(244, 75, 72, 0.5)");
  }
  let id = null as any;
  /**圆半径 */
  let radius = 1;
  /**圆心 */
  let lngLat = [] as any;
  let entity = null as any;
  let entityCenter = null;
  let entityCenter2 = null;
  let entityLabelist = null as any;
  let infoDetail = {
    circle: [] as any,
  };
  let lineLast = null as any;

  handler.setInputAction((click: any) => {
    if (typeNum.value == 2 || typeNum.value == 4) {
      /**点击位置笛卡尔坐标 */
      // let cartesian = viewer.scene.pickPosition(click.position);
      let ray = viewer.camera.getPickRay(click.position);
      let cartesian = viewer.scene.globe.pick(ray, viewer.scene);
      let cartographic = Cesium.Cartographic.fromCartesian(cartesian);
      let lng = Cesium.Math.toDegrees(cartographic.longitude);
      let lat = Cesium.Math.toDegrees(cartographic.latitude);
      lngLat = [lng, lat, 0];
      // console.log(cartesian, "查看点击位置笛卡尔坐标", lng, lat);
      entity = viewer.entities.add({
        position: new Cesium.CallbackProperty(function () {
          return new Cesium.Cartesian3.fromDegrees(...lngLat);
        }, false),
        name: "circle",
        id: id,
        ellipse: {
          outline: true,
          material: circleBg,
          outlineColor: Cesium.Color.BLUE,
          outlineWidth: 2,
          // clampToGround: true,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
        },
      });
      entityCenter = viewer.entities.add({
        name: `circlePoint`,
        position: Cesium.Cartesian3.fromDegrees(lng, lat),
        point: {
          pixelSize: 10.0,
          color: Cesium.Color.WHITE.withAlpha(1),
          outlineWidth: 1,
          outlineColor: Cesium.Color.WHITE,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
        },
      });

      entityLabelist = viewer.entities.add({
        position: Cesium.Cartesian3.fromDegrees(lng, lat),
        billboard: {
          image: "", // 使用生成的图片
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // 水平对齐
          verticalOrigin: Cesium.VerticalOrigin.CENTER, // 垂直对齐
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        },
        customData: Date.now(),
        labelWidth: radius.toFixed(2),
      });

      entity.ellipse.semiMajorAxis = new Cesium.CallbackProperty(function () {
        return radius;
      }, false);
      entity.ellipse.semiMinorAxis = new Cesium.CallbackProperty(function () {
        return radius;
      }, false);
      // console.log(entity, "entity");
      if (lngLat) {
        handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
      }

      handler.setInputAction((move: any) => {
        // let cartesian2 = viewer.camera.pickEllipsoid(
        //   move.endPosition,
        //   viewer.scene.globe.ellipsoid
        // );
        // console.log(8511, move.position, move);

        let ray = viewer.camera.getPickRay(move.endPosition);
        let cartesian2 = viewer.scene.globe.pick(ray, viewer.scene);
        radius = Cesium.Cartesian3.distance(cartesian, cartesian2);
        let closestPoint = null as any;
        let res = calculateNewLocation3(lngLat[0], lngLat[1], radius, 90);
        if (
          isPointInsideCircle(
            lngLat[1],
            lngLat[0],
            radius,
            res.newLatitude,
            res.newLongitude
          )
        ) {
        } else {
          // 如果点不在圆内，获取最接近的点
          closestPoint = getClosestPointOnCircle(
            lngLat[1],
            lngLat[0],
            radius,
            res.newLatitude,
            res.newLongitude
          );
          const labelImage = createLabelWithBackground(
            `${radius.toFixed(2)}m`,
            "14px sans-serif",
            "white",
            "rgba(30, 30, 30, 0.7)"
          );

          const points = Cesium.Cartesian3.fromDegrees(
            closestPoint.lon,
            closestPoint.lat
          );
          let middlePosition = Cesium.Cartesian3.lerp(
            cartesian,
            points,
            0.5,
            new Cesium.Cartesian3()
          );
          entityLabelist.position = new Cesium.CallbackProperty(() => {
            return middlePosition;
          }, false);
          entityLabelist.billboard.image = labelImage;

          if (lineLast == null) {
            lineLast = viewer.entities.add({
              polyline: {
                positions: new Cesium.CallbackProperty(function () {
                  return [cartesian, points];
                }, false),
                material: Cesium.Color.WHITE.withAlpha(0.5),
                width: 5, // 设置线段宽度
                clampToGround: true,
              },
            });
          } else {
            lineLast.polyline.positions = new Cesium.CallbackProperty(() => {
              return [cartesian, points];
            }, false);
          }
        }
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

      handler.setInputAction(() => {
        infoDetail.circle.push({
          id: id,
          center: lngLat,
          radius: radius.toFixed(2),
        });
        let closestPoint = null as any;
        let res = calculateNewLocation3(lngLat[0], lngLat[1], radius, 90);
        // 判断当前点是否在圆内
        if (
          isPointInsideCircle(
            lngLat[1],
            lngLat[0],
            radius,
            res.newLatitude,
            res.newLongitude
          )
        ) {
          // console.log("点在圆内");
        } else {
          // 如果点不在圆内，获取最接近的点
          closestPoint = getClosestPointOnCircle(
            lngLat[1],
            lngLat[0],
            radius,
            res.newLatitude,
            res.newLongitude
          );
          // console.log(
          //   `点不在圆内，最近点为：纬度 = ${closestPoint.lat}, 经度 = ${closestPoint.lon}`
          // );
        }
        entityCenter2 = viewer.entities.add({
          name: `circlePointRight`,
          position: Cesium.Cartesian3.fromDegrees(
            closestPoint.lon,
            closestPoint.lat
          ),
          point: {
            pixelSize: 10.0,
            color: Cesium.Color.WHITE.withAlpha(1),
            outlineWidth: 1,
            outlineColor: Cesium.Color.WHITE,
            heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
          },
        });
        handler.destroy();
        //   console.log(entity, "entity123456", infoDetail);
        let params = {
          entity,
          infoDetail,
        };
        callback(params);
        // handleDrawCircle()
      }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);
    }
  }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
}

function calculateNewLocation3(
  longitude: any,
  latitude: any,
  distanceInMeters: any,
  angleInDegrees: any
) {
  // 将经纬度转换为弧度
  let currentLongitudeRadians = Cesium.Math.toRadians(longitude);
  let currentLatitudeRadians = Cesium.Math.toRadians(latitude);
  let angleInRadians = Cesium.Math.toRadians(angleInDegrees);

  // 计算新位置的纬度
  let newLatitudeRadians = Math.asin(
    Math.sin(currentLatitudeRadians) * Math.cos(distanceInMeters / 6378137) +
      Math.cos(currentLatitudeRadians) *
        Math.sin(distanceInMeters / 6378137) *
        Math.cos(angleInRadians)
  );

  // 计算新位置的经度
  let newLongitudeRadians =
    currentLongitudeRadians +
    Math.atan2(
      Math.sin(angleInRadians) *
        Math.sin(distanceInMeters / 6378137) *
        Math.cos(currentLatitudeRadians),
      Math.cos(distanceInMeters / 6378137) -
        Math.sin(currentLatitudeRadians) * Math.sin(newLatitudeRadians)
    );

  // 将弧度转换为经纬度
  let newLongitude = Cesium.Math.toDegrees(newLongitudeRadians);
  let newLatitude = Cesium.Math.toDegrees(newLatitudeRadians);

  return { newLongitude, newLatitude };
}
// 判断点是否在圆内
function isPointInsideCircle(
  centerLat: any,
  centerLon: any,
  radius: any,
  pointLat: any,
  pointLon: any
) {
  // 计算圆心和点之间的距离
  const geodesic = new Cesium.EllipsoidGeodesic();
  geodesic.setEndPoints(
    Cesium.Cartographic.fromDegrees(centerLon, centerLat),
    Cesium.Cartographic.fromDegrees(pointLon, pointLat)
  );
  const distance = geodesic.surfaceDistance;

  return distance <= radius;
}

// 计算从圆心到点的最短距离，返回最接近的点的经纬度
function getClosestPointOnCircle(
  centerLat: any,
  centerLon: any,
  radius: any,
  pointLat: any,
  pointLon: any
) {
  // 计算圆心到点的距离
  const geodesic = new Cesium.EllipsoidGeodesic();
  geodesic.setEndPoints(
    Cesium.Cartographic.fromDegrees(centerLon, centerLat),
    Cesium.Cartographic.fromDegrees(pointLon, pointLat)
  );
  const distance = geodesic.surfaceDistance;

  if (distance <= radius) {
    // 如果点在圆内，返回该点
    return { lat: pointLat, lon: pointLon };
  }

  // 计算比例系数，得到最接近的点
  const scale = radius / distance;

  // 计算最近点的经纬度
  const radianLat1 = Cesium.Math.toRadians(centerLat);
  const radianLon1 = Cesium.Math.toRadians(centerLon);
  const radianLat2 = Cesium.Math.toRadians(pointLat);
  const radianLon2 = Cesium.Math.toRadians(pointLon);

  const deltaLon = radianLon2 - radianLon1;
  const deltaLat = radianLat2 - radianLat1;

  // 计算最接近点的纬度和经度
  const newLat = centerLat + scale * deltaLat * (180 / Math.PI);
  const newLon = centerLon + scale * deltaLon * (180 / Math.PI);

  return { lat: newLat, lon: newLon };
}
// 绘制 线
function drawLine(params: any) {}
